import { loggedIn, userActive } from '../../../routes/conditional';
import paths from '../../../routes/paths';

export const page = {
    path: paths.signup.complete,
    isAllowed: [loggedIn, userActive],
};

export const actions = {};
